import Icon from '../../components/Icon.vue'

Icon.register({"brands/wpbeginner":{"width":512,"height":512,"paths":[{"d":"M462.8 322.4C519 386.7 467 480 370.9 480 331.3 480 292.1 462.3 270.8 430 263.9 430.3 248.1 430.3 241.2 430 219.8 462.4 180.6 480 141.1 480 45.6 480-7.3 387 49.2 322.4-29.9 190.5 80.5 32 256 32 431.6 32 541.9 190.6 462.8 322.4zM123.2 239.4H164.7V181.3H123.2V239.4zM340.3 325.5V301.6C279.8 322.6 208 310.8 152.7 267.7L153 292.6C204.1 338.9 284.7 350.4 340.3 325.5zM189.6 239.4H355.6V181.3H189.6V239.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/wpbeginner.js
// module id = null
// module chunks = 